var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{},[_c('v-col',{attrs:{"cols":"3"}}),_c('v-col',{staticClass:"mb-4",attrs:{"cols":"6"}},[_c('SettingsForm')],1),_c('v-col',{attrs:{"cols":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }